<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="3" y="5" width="18" height="16" rx="3" stroke="currentColor" stroke-width="2" />
  <path d="M7 2.5V5.5M17 2.5V5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  <path d="M3 9.5H21" stroke="currentColor" stroke-width="2" />
  <rect x="6.5" y="12" width="2" height="2" rx="0.5" fill="currentColor" />
  <rect x="11" y="12" width="2" height="2" rx="0.5" fill="currentColor" />
  <rect x="15.5" y="12" width="2" height="2" rx="0.5" fill="currentColor" />
  <rect x="6.5" y="16" width="2" height="2" rx="0.5" fill="currentColor" />
  <rect x="11" y="16" width="2" height="2" rx="0.5" fill="currentColor" />
  <rect x="15.5" y="16" width="2" height="2" rx="0.5" fill="currentColor" />
</svg>
